var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1"
    },
    [
      _c(
        "div",
        { staticClass: "p-2" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "schedule_events.create",
                  expression: "'schedule_events.create'"
                },
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: {
                "aria-controls": "sidebar-add-new-event",
                "aria-expanded": String(_vm.isEventHandlerSidebarActive),
                variant: "primary",
                block: ""
              },
              on: {
                click: function($event) {
                  return _vm.$emit("update:isEventHandlerSidebarActive", true)
                }
              }
            },
            [_vm._v(" Adicionar Evento ")]
          ),
          _c(
            "div",
            { key: _vm.key, staticClass: "mt-3" },
            [
              _vm._m(0),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mb-1",
                  model: {
                    value: _vm.checkAll,
                    callback: function($$v) {
                      _vm.checkAll = $$v
                    },
                    expression: "checkAll"
                  }
                },
                [_vm._v(" Visualizar todos ")]
              ),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-checkbox-group",
                    {
                      attrs: { name: "event-filter", stacked: "" },
                      model: {
                        value: _vm.selectedCalendars,
                        callback: function($$v) {
                          _vm.selectedCalendars = $$v
                        },
                        expression: "selectedCalendars"
                      }
                    },
                    _vm._l(_vm.calendarTypes, function(item) {
                      return _c(
                        "b-form-checkbox",
                        {
                          key: item.name,
                          staticClass: "mb-1",
                          attrs: { name: "event-filter", value: item.id }
                        },
                        [
                          _c("span", { style: "color: " + item.color }, [
                            _vm._v(_vm._s(item.name))
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { key: _vm.key, staticClass: "mt-3" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "flex flex-row gap-0 items-center" },
              [
                _c(
                  "div",
                  { staticClass: "__author-select" },
                  [
                    _c(
                      "vs-select",
                      {
                        attrs: {
                          autocomplete: "",
                          options: _vm.scheduleAuthors
                        },
                        model: {
                          value: _vm.schedule_author,
                          callback: function($$v) {
                            _vm.schedule_author = $$v
                          },
                          expression: "schedule_author"
                        }
                      },
                      _vm._l(_vm.scheduleAuthors, function(item, index) {
                        return _c("vs-select-item", {
                          key: index,
                          attrs: { value: item.value, text: item.text }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm.schedule_author
                  ? _c("b-icon-x", {
                      staticClass:
                        "text-red-light hover:text-red cursor-pointer",
                      attrs: { "font-scale": "2" },
                      on: {
                        click: function($event) {
                          _vm.schedule_author = null
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("b-img", {
        attrs: {
          src: require("@/assets/images/pages/calendar-illustration.png")
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "app-label section-label mb-1" }, [
      _c("span", { staticClass: "align-middle" }, [_vm._v("Calendários")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "app-label section-label mb-1" }, [
      _c("span", { staticClass: "align-middle" }, [_vm._v("Responsável")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }